export function downloadFile(document, file, fileName) {
    const a = document.createElement("a");
    const objectUrl = window.URL.createObjectURL(new Blob([file]));

    a.href = objectUrl;
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(objectUrl);
}